
















import Vue from "vue"
import SectionTitle from "~/components/guideline/util/SectionTitleWithIcon.vue"

export default Vue.extend({
  components: {
    SectionTitle,
  },
  props: {
    projectHelp: {
      type: String,
      required: true,
    },
    formPath: {
      type: String,
      default: null,
    },
  },
})
